import {Tooltip as ChakraTooltip} from "@chakra-ui/react";
import * as React from "react";
import {useForwardedRef} from "../../hooks/forwardedRef";
import {Portal} from "../Portal";

export interface TooltipProps extends ChakraTooltip.RootProps {
  showArrow?: boolean;
  portalled?: boolean;
  portalRef?: React.RefObject<HTMLElement>;
  content: React.ReactNode;
  contentProps?: ChakraTooltip.ContentProps;
  disabled?: boolean;
}

export const Tooltip = React.forwardRef<HTMLDivElement, TooltipProps>(function Tooltip(props, ref) {
  const {showArrow = true, children, disabled, portalled = true, content, contentProps, portalRef, ...rest} = props;
  const contentRef = useForwardedRef(ref);

  if (disabled) return children;

  return (
    <ChakraTooltip.Root openDelay={200} closeDelay={200} {...rest}>
      <ChakraTooltip.Trigger asChild>{children}</ChakraTooltip.Trigger>
      <Portal disabled={!portalled} container={portalRef}>
        <ChakraTooltip.Positioner>
          <ChakraTooltip.Content ref={contentRef} {...contentProps}>
            {showArrow && (
              <ChakraTooltip.Arrow>
                <ChakraTooltip.ArrowTip />
              </ChakraTooltip.Arrow>
            )}
            {content}
          </ChakraTooltip.Content>
        </ChakraTooltip.Positioner>
      </Portal>
    </ChakraTooltip.Root>
  );
});
